"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnactionedTeamNotifications = exports.getUnactionedNotifications = exports.getActionedTeamNotifications = exports.getActionedNotifications = void 0;
const axios_1 = __importDefault(require("axios"));
const baseUrl = '/https2-notifications';
async function getActionedNotifications(startAt, fetchCount) {
    let params = '?';
    if (startAt) {
        params += `startAt=${startAt}`;
    }
    if (fetchCount) {
        params += (params === '?' ? '' : '&') + `limit=${fetchCount}`;
    }
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/api/notifications/actioned${params}`
    });
    return resp.data;
    // return actionedNotifications
}
exports.getActionedNotifications = getActionedNotifications;
async function getActionedTeamNotifications(userId, startAt, fetchCount) {
    console.log('getActionedTeamNotifications:userId', userId);
    let params = '?';
    if (startAt) {
        params += `startAt=${startAt}`;
    }
    if (fetchCount) {
        params += (params === '?' ? '' : '&') + `limit=${fetchCount}`;
    }
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/api/notifications/actioned/${userId}${params}`
    });
    return resp.data;
    // return actionedTeamNotifications
}
exports.getActionedTeamNotifications = getActionedTeamNotifications;
async function getUnactionedNotifications() {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/api/notifications/unactioned`
    });
    return resp.data;
}
exports.getUnactionedNotifications = getUnactionedNotifications;
async function getUnactionedTeamNotifications(userId) {
    console.log('getUnactionedTeamNotifications:userId', userId);
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/api/notifications/unactioned/${userId}`
    });
    return resp.data;
}
exports.getUnactionedTeamNotifications = getUnactionedTeamNotifications;
